import { Pipe, PipeTransform } from '@angular/core';
import { ObjectUtil } from '../utils';
import { SharedConstants } from '@app/eds';

@Pipe({
  name: 'statusValue'
})
export class StatusValuePipe implements PipeTransform {
  public transform(
    object: { [key: string]: any },
    props: string,
    defaultValue: string = SharedConstants.EMPTY_STRING,
    customReturnValue?: (_v: string) => string
  ): string {
    if (!object) {
      return defaultValue;
    }

    const _value: string = ObjectUtil.queryValue(object, props);

    if (customReturnValue) {
      const _v = customReturnValue(_value);
      return _v || defaultValue;
    }

    return _value;
  }
}
